import { Link } from "react-router-dom";
import { ArrowLeft, Download, Loader2, Lock, CheckCircle2 } from "lucide-react";

const SAVE_LABEL = { saved: "Saved", saving: "Saving…", unsaved: "Unsaved changes", error: "Save failed, retrying" };

export const EditorToolbar = ({ doc, update, saveState, onDownload, exporting, children }) => (
  <div className="border-b border-paper-border bg-white/70 backdrop-blur">
    <div className="mx-auto flex max-w-[1500px] flex-wrap items-center gap-3 px-4 py-3 sm:px-6">
      <Link to="/app" className="btn-ink !px-2.5 !py-2" data-testid="back-to-documents-btn" aria-label="Back"><ArrowLeft className="h-4 w-4" /></Link>
      <div className="min-w-[160px] flex-1">
        <input value={doc.title} onChange={(e) => update({ title: e.target.value })} maxLength={120} data-testid="doc-title-input"
          className="w-full bg-transparent font-serif text-xl text-ink outline-none placeholder:text-taupe focus:border-b focus:border-thread" placeholder="Untitled" />
        <p className="font-mono text-[11px] text-taupe" data-testid="save-status">{SAVE_LABEL[saveState]}</p>
      </div>
      {children}
      <button className="btn-thread" onClick={onDownload} disabled={exporting} data-testid="download-pdf-btn">
        {exporting ? <Loader2 className="h-4 w-4 animate-spin" /> : doc.can_download ? <Download className="h-4 w-4" /> : <Lock className="h-4 w-4" />}
        Download PDF
      </button>
      {doc.can_download && <span className="inline-flex items-center gap-1 text-xs font-medium text-green-700" data-testid="unlocked-badge"><CheckCircle2 className="h-4 w-4" /> Unlocked</span>}
    </div>
  </div>
);

export const SplitLayout = ({ form, preview, tab, setTab }) => (
  <>
    <div className="flex gap-1 border-b border-paper-border bg-paper px-4 pt-2 lg:hidden">
      {[["edit", "Edit"], ["preview", "Preview"]].map(([k, l]) => (
        <button key={k} onClick={() => setTab(k)} data-testid={`mobile-tab-${k}`}
          className={`rounded-t-md px-4 py-2 text-sm font-semibold ${tab === k ? "border-b-2 border-thread text-ink" : "text-ink-soft"}`}>{l}</button>
      ))}
    </div>
    <div className="mx-auto grid max-w-[1500px] lg:h-[calc(100vh-130px)] lg:grid-cols-2">
      <div className={`overflow-y-auto px-4 py-6 sm:px-6 lg:block ${tab === "edit" ? "" : "hidden"}`}>{form}</div>
      <div className={`paper-grain overflow-y-auto border-l border-paper-border bg-paper-subtle px-4 py-8 sm:px-8 lg:block ${tab === "preview" ? "" : "hidden"}`}>{preview}</div>
    </div>
  </>
);
